import {Modal, Switch, Button} from "antd";
import React, {useState, useEffect} from "react";
import styled from "styled-components";

const ModalContent = styled.div`
    padding: 20px 0;
`;

const PaymentTypeRow = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 0;
    border-bottom: 1px solid #f0f0f0;

    &:last-child {
        border-bottom: none;
    }
`;

const PaymentTypeLabel = styled.span`
    font-size: 16px;
    color: #333;
`;

const ButtonContainer = styled.div`
    display: flex;
    justify-content: flex-end;
    padding-top: 20px;
    border-top: 1px solid #f0f0f0;
    margin-top: 20px;
`;

export const PaymentTypesGroupingModal = ({
    openPaymentTypesGroupingModal,
    setOpenPaymentTypesGroupingModal,
    paymentTypeMap,
    setPaymentTypes,
    currentPaymentTypes
}) => {
    const [paymentTypeStates, setPaymentTypeStates] = useState(() => {
        // Use current payment types from meStore or default to all true
        if (currentPaymentTypes && Object.keys(currentPaymentTypes).length > 0) {
            return {...currentPaymentTypes};
        }

        const initialStates = {};
        Object.keys(paymentTypeMap).forEach(key => {
            initialStates[key] = true;
        });
        return initialStates;
    });

    // Update local state when modal opens and currentPaymentTypes changes
    useEffect(() => {
        if (openPaymentTypesGroupingModal && currentPaymentTypes) {
            setPaymentTypeStates({...currentPaymentTypes});
        }
    }, [openPaymentTypesGroupingModal, currentPaymentTypes]);

    const handleSwitchChange = (paymentType, checked) => {
        setPaymentTypeStates(prev => ({
            ...prev,
            [paymentType]: checked
        }));
    };

    const handleSaveGroups = () => {
        setOpenPaymentTypesGroupingModal(false);
        setPaymentTypes(paymentTypeStates);
    };

    return (
        <Modal
            visible={openPaymentTypesGroupingModal}
            onCancel={() => setOpenPaymentTypesGroupingModal(false)}
            footer={null}
            width={500}
            centered
            destroyOnClose
        >
            <div>
                <h3>Ödeme Yöntemlerini Filtrele</h3>
                <ModalContent>
                    {Object.entries(paymentTypeMap).map(([key, label]) => (
                        <PaymentTypeRow key={key}>
                            <PaymentTypeLabel>{label}</PaymentTypeLabel>
                            <Switch
                                checked={paymentTypeStates[key]}
                                onChange={checked => handleSwitchChange(key, checked)}
                                style={{
                                    backgroundColor: paymentTypeStates[key] ? "#AEF001" : "#f0f0f0",
                                    borderColor: paymentTypeStates[key] ? "#AEF001" : "#f0f0f0"
                                }}
                            />
                        </PaymentTypeRow>
                    ))}
                </ModalContent>

                <ButtonContainer>
                    <Button
                        onClick={handleSaveGroups}
                        style={{
                            backgroundColor: "#AEF001",
                            border: "none",
                            color: "#000",
                            width: "150px",
                            height: "40px"
                        }}
                    >
                        Kaydet
                    </Button>
                </ButtonContainer>
            </div>
        </Modal>
    );
};
